import React, { Component } from 'react'

class OpenAnswer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      answer: ''
    }
  }

  componentDidMount () {
    const { myVote } = this.props
    myVote && this.setState({ answer: myVote.vote })
  }

  isAnswerNew () {
    let { myVote } = this.props
    myVote = myVote || { vote: '' }

    return myVote.vote !== this.state.answer && this.state.answer !== ''
  }

  render () {
    const { handleVoting } = this.props

    return (
      <div className='vote-bttns-container'>
        <textarea
          className='vote-answer'
          value={this.state.answer}
          onChange={ev => this.setState({ answer: ev.target.value })}
        />
        <button
          onClick={() => handleVoting(this.state.answer)}
          className={`button vote-submit ${!this.isAnswerNew() && 'inactive-bttn'}`}>
          submit
        </button>
      </div>
    )
  }
}

export default OpenAnswer



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/OpenAnswer.js